import React from "react";
import CloseIcon from "@mui/icons-material/Close";
// import { display } from "@mui/system";

const UserSelectedItem = (props) => {
  // console.log("props", props.userInfo);
  return (
    <div
      onClick={props.selectedUserDelete}
      style={{
        padding: "2px 5px 2px 5px",
        borderRadius: "5px",
        margin: "5px",
        fontSize: "15px",
        background: "#38b2ac8f",
        cursor: "pointer",
        width: "fit-content",
        float: "left",
      }}
    >
      {/* ---using now--- */}

      {props.userInfo && props.userInfo._id === props.user._id ? (
        <>
          (You) {props.user.name} <CloseIcon style={{ fontSize: "15px" }} />
        </>
      ) : (
        <>
          {props.user.name} <CloseIcon style={{ fontSize: "15px" }} />
        </>
      )}

      {/* ---using before--- */}
      {/* {props.user.name}   <CloseIcon style={{fontSize:"15px"}}/> */}
    </div>
  );
};

export default UserSelectedItem;
